import React, {Component} from 'react';
import {connect} from 'react-redux';
// import util from 'Utils/commonUtil';

// Components
import {Card, Grid} from '@material-ui/core';
import Counter from 'Components/counter/Counter';
import ProductImage from 'Components/commonOrder/ProductImage';
import Anchor from 'Components/common/Anchor';
import CommonDialogWrapper from './CommonShippingDetails';
import {loadLanguage} from 'Utils/jwtUtil';

import {T} from 'Actions/translate';
import {getSkuReplenishmentDetails} from 'Actions/host';
import PropTypes from 'prop-types';

class ReplenishmentProductDetailsCard extends Component {
    state = {
        num: 0,
        exitOpened: false,
    };

    changeNum = (value) => {
        this.setState({
            num: value,
        });
        if (this.props.changeNum) {
            this.props.changeNum(this.props.f1OrderProduct, value);
        }
    };

    openDialog = (name, orderId, productId) => {
        this.setState({
            [name]: true,
        });
        this.props.getSkuReplenishmentDetails({
            orderId: orderId,
            productId: productId,
        });
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    showShippmentDetails = (orderId, productId) => {
        this.openDialog('exitOpened', orderId, productId);
    };
    render() {
        const {f1OrderProduct, skuReplenishmentDetail} = this.props;
        const {exitOpened} = this.state;
        const tableThContent = [
            'host_fone_receive_amount',
            'host_fone_receive_date',
        ];
        let lang = loadLanguage();

        return (
            <Card className="replenishment-product-card">
                <Grid
                    className="replenishment-product-content"
                    container
                    spacing={0}>
                    <Grid className="left-content-grid" item xs={4}>
                        <div className="image-box">
                            <ProductImage
                                src={
                                    f1OrderProduct.product &&
                                    f1OrderProduct.product.productPic
                                }
                                key={
                                    f1OrderProduct.product &&
                                    f1OrderProduct.product.productPic
                                }
                                alt={
                                    f1OrderProduct.product &&
                                    f1OrderProduct.product.productName
                                }
                            />
                        </div>
                    </Grid>

                    <Grid className="right-content-grid" item xs={8}>
                        <Grid
                            className="product-details"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid className="sc-sku" item xs={12}>
                                <span>{f1OrderProduct.product.sku}</span>
                            </Grid>

                            <Grid
                                className="received-quantity-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="quantity-title"
                                    item
                                    xs={lang === 'EN' ? 8 : 4}>
                                    <span>
                                        {T('fone_order_received_amount')}
                                    </span>
                                </Grid>

                                <Grid
                                    className="quantity"
                                    item
                                    xs={lang === 'EN' ? 4 : 8}>
                                    <span>
                                        {f1OrderProduct.receivedQuantity}
                                    </span>
                                </Grid>
                            </Grid>

                            <Grid
                                className="bottom-content-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="counter-title"
                                    item
                                    xs={lang === 'EN' ? 6 : 4}>
                                    <span>
                                        {T('fone_order_replenished_amount')}
                                    </span>
                                </Grid>

                                <Grid
                                    className="counter"
                                    item
                                    xs={lang === 'EN' ? 6 : 8}>
                                    <Counter
                                        inputValid={this.changeNum}
                                        defalutValue={
                                            f1OrderProduct.quantity > 0
                                                ? f1OrderProduct.quantity
                                                : 0
                                        }
                                        options={{
                                            value: 0,
                                            min: f1OrderProduct.receivedQuantity,
                                        }}></Counter>
                                </Grid>
                            </Grid>

                            <Grid
                                className="sku-specifications-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="specifications-title"
                                    item
                                    xs={12}>
                                    <span>
                                        {T('product_specifications_colon')}
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: f1OrderProduct.product
                                                    .specifications,
                                            }}
                                        />
                                    </span>
                                </Grid>

                                <Grid
                                    className="shipping-detail-href"
                                    item
                                    xs={12}>
                                    <Anchor
                                        className={
                                            f1OrderProduct.receivedQuantity ===
                                            0
                                                ? 'btn btn-disabled'
                                                : 'btn'
                                        }
                                        disabled={
                                            f1OrderProduct.receivedQuantity ===
                                            0
                                                ? true
                                                : false
                                        }
                                        onClickOfSingleTap={() =>
                                            this.showShippmentDetails(
                                                f1OrderProduct.orderId,
                                                f1OrderProduct.productId,
                                            )
                                        }>
                                        {T('fone_order_shippment_details')}
                                    </Anchor>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <CommonDialogWrapper
                    tableThContent={tableThContent}
                    skuReplenishmentDetailData={skuReplenishmentDetail}
                    closeDialog={this.closeDialog}
                    exitOpened={exitOpened}
                />
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        skuReplenishmentDetail: host.skuReplenishmentDetail,
    };
};

const mapDispatchToProps = {
    getSkuReplenishmentDetails,
};

ReplenishmentProductDetailsCard.propTypes = {
    getSkuReplenishmentDetails: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReplenishmentProductDetailsCard);
